module.exports = __webpack_public_path__ + "img/奔宝卢卡斯.png";